import { Injectable } from '@angular/core';
import { catchError,map } from 'rxjs/operators';
import { Router } from '@angular/router';
import { AlertHelper } from 'src/app/shared/components/helpers/alert.helpers';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { RequestResponse } from 'src/app/shared/models/request-response.interface';
import { Observable, throwError } from 'rxjs';
import { EstadoCivil, RequestResponseGetAllEstadoCivil, RequestResponseActualizar } from 'src/app/shared/models/estado-civil.interface';

@Injectable({
  providedIn: 'root'
})
export class EstadoCivilService {

  constructor(private http:HttpClient,private router: Router,private alert:AlertHelper) { }


  //GetAll_estadoCivils
  traerTodosEstadoCivils(): Observable<RequestResponseGetAllEstadoCivil> {
    return this.http
    .get<RequestResponseGetAllEstadoCivil >(`${environment.API}/rrhh/estado/`)
    .pipe(
      map((res:RequestResponseGetAllEstadoCivil) =>{          
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  
  //Create_estadoCivil
  crearEstadoCivil(estadoCivil:EstadoCivil): Observable<RequestResponse> {     
    return this.http
    .post<RequestResponse >(`${environment.API}/rrhh/estado/crear/`,estadoCivil)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Actualizar_estadoCivil
  actualizarEstadoCivil(estadoCivil:any): Observable<RequestResponseActualizar>  {
    return this.http
    .put<RequestResponseActualizar >(`${environment.API}/rrhh/estado/editar/${estadoCivil.id}`,estadoCivil)
    .pipe(
      map((res:RequestResponseActualizar) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
  //Obtener_estado
  obtenerEstadoCivil(id:number): Observable<RequestResponse> {
    return this.http
    .get<RequestResponse >(`${environment.API}/rrhh/estado/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }


  private handlerError(err: any):Observable<never>{

    let errorMessage = "";
    if (err) {
      errorMessage = `Error: ${err.error.msg}`;
    }
    this.alert.error_small(err.error.msg);
    return throwError(errorMessage);
  }
  //Eliminar_EstadoCivil
  eliminarEstadoCivil(id:number): Observable<RequestResponse> {
    return this.http
    .delete<RequestResponse >(`${environment.API}/rrhh/estado/eliminar/${id}`)
    .pipe(
      map((res:RequestResponse) =>{
        return res;
      }),
      catchError((err)=> this.handlerError(err))
    );
  }
}
